import { WarningModalComponent } from "./../warning-modal/warning-modal.component";
import { Component, ViewEncapsulation } from "@angular/core";
import { Language } from "../../models/language";
import { Channel } from "../../models/channel";
import { Schedule } from "../../models/schedule";
import { ScheduleService } from "../../services/schedule.service";
import { MdDialog, MdDialogRef } from "@angular/material";
import { User } from "../../models/user";
import { Subscription } from "rxjs/Subscription";
import { ChannelService } from "../../services/channel.service";
import { Store } from "@ngrx/store";
import { SuccessComponent } from "../success/success.component";
//import { Console } from 'console';
import { NgModel } from "@angular/forms";

@Component({
  selector: "app-magic-box-schedule",
  templateUrl: "./magic-box-schedule.component.html",
  styleUrls: ["./magic-box-schedule.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MagicBoxScheduleComponent {
  schedule: Schedule;
  scheduleMbx: Schedule[];
  languages: Language[];
  channels: Channel[];
  subscriptions: Subscription[];
  now = new Date();
  loading: boolean;
  gridVisible: boolean;
  infoVisible: boolean;
  canBeScheduled: boolean;

  private dialogWarning: MdDialogRef<WarningModalComponent>;

  /**
   * Initialize variables and get data
   * @param {ScheduleService} scheduleService
   * @param {MdDialog} mdDialog
   * @param {Store<any>} store
   * @param {ChannelService} channelService
   */
  constructor(
    private scheduleService: ScheduleService,
    private mdDialog: MdDialog,
    private store: Store<any>,
    private channelService: ChannelService
  ) {
    this.schedule = new Schedule({});
    this.schedule.startDate = new Date();
    this.subscriptions = [];
    this.loading = true;
    this.gridVisible = false;
    this.infoVisible = false;

    /**
     * Get current user, current language and get channels
     */
    this.subscriptions.push(
      this.store.select("userState").subscribe((user: User) => {
        if (user && user.currentLanguage) {
          this.languages = user.languages;
          this.schedule.languages.unshift(user.currentLanguage);
          this.schedule.email = user.email;
          this.getChannels();
        }
      })
    );
  }

  /**
   * Check dates before saving schedule
   */
  saveSchedule() {
    var diff = Math.abs(
      this.schedule.startDate.getTime() - this.schedule.endDate.getTime()
    );
    var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
    let stringLanguages = this.schedule.languages
      .map((language) => language.value)
      .toString();

    let stringChannels = this.schedule.languages
      .map((language) => language.value)
      .toString();

    if (diffDays > 180) {
      // 6 months
      // blocked
      this.mdDialog.open(SuccessComponent, {
        data: {
          type: "error",
          message: "Please create a schedule for less than 6 month.",
        },
      });
    } else if (diffDays > 60) {
      // 2 months
      // warning
      this.dialogWarning = this.mdDialog.open(WarningModalComponent, {
        data: {
          title:
            "This action will require a lot of workload and might slow Taiga down.",
          content:
            "Do you want to proceed with the following schedules : <br> <b> languages : " +
            stringLanguages +
            " - channels : " +
            stringChannels +
            " - from " +
            this.schedule.startDate.toLocaleDateString() +
            " to " +
            this.schedule.endDate.toLocaleDateString() +
            " ?</b>",
        },
      });

      this.dialogWarning.afterClosed().subscribe((result) => {
        if (result == "no") {
          return;
        } else {
          this.save();
        }
      });
    } else {
      this.save();
    }
  }

  /**
   * Save schedule by calling the API
   */
  save() {
    this.loading = true;
    this.scheduleService.saveSchedule(this.schedule).subscribe(() => {
      this.mdDialog.closeAll();
      this.mdDialog.open(SuccessComponent, {
        data: { message: "Schedule has been created" },
      });
      this.loading = false;
      this.gridVisible = false;
    });
  }

  /**
   * If date change, check if start date is lower than end date
   */
  dateChange() {
    if (
      this.schedule.endDate &&
      this.schedule.endDate.getTime() < this.schedule.startDate.getTime()
    ) {
      this.schedule.endDate = this.schedule.startDate;
    }
    this.CheckMagicBoxScheduleAvailibility();
  }

  selectAllLanguages(select: NgModel, event) {
    if (event.checked) {
      select.update.emit(this.languages);
    } else {
      select.update.emit([]);
    }
    this.getChannels();
  }

  allLanguagesSelected() {
    return this.schedule.languages.length === this.languages.length;
  }

  selectPopupCountries(select: NgModel, event) {
    if (event.checked) {
      select.update.emit(
        this.schedule.languages.concat(
          this.languages.filter(
            (language) =>
              language.value === "INTERNATIONAL" ||
              language.value === "GERMAN" ||
              language.value === "ENGLISH" ||
              language.value === "FRENCH" ||
              language.value === "ITALIAN" ||
              language.value === "DUTCH" ||
              language.value === "SPANISH" ||
              language.value === "POLISH" ||
              language.value === "RUSSIAN" ||
              language.value === "ROMANIAN"
          )
        )
      );
    } else {
      select.update.emit(
        this.schedule.languages.filter(
          (language) =>
            !(
              language.value === "INTERNATIONAL" ||
              language.value === "GERMAN" ||
              language.value === "ENGLISH" ||
              language.value === "FRENCH" ||
              language.value === "ITALIAN" ||
              language.value === "DUTCH" ||
              language.value === "SPANISH" ||
              language.value === "POLISH" ||
              language.value === "RUSSIAN" ||
              language.value === "ROMANIAN"
            )
        )
      );
    }
    this.getChannels();
  }

  popupCountriesSelected() {
    return (
      this.schedule.languages.filter(
        (language) =>
          language.value === "INTERNATIONAL" ||
          language.value === "GERMAN" ||
          language.value === "ENGLISH" ||
          language.value === "FRENCH" ||
          language.value === "ITALIAN" ||
          language.value === "DUTCH" ||
          language.value === "SPANISH" ||
          language.value === "POLISH" ||
          language.value === "RUSSIAN" ||
          language.value === "ROMANIAN"
      ).length === 10
    );
  }

  selectAllChannels(select: NgModel, event) {
    if (event.checked) {
      select.update.emit(this.channels);
    } else {
      select.update.emit([]);
    }
  }

  allChannelsSelected() {
    return this.schedule.channels.length === this.channels.length;
  }

  selectLinearChannels(select: NgModel, event) {
    if (event.checked) {
      select.update.emit(
        this.schedule.channels.concat(
          this.channels.filter((channel) => channel.isLinear)
        )
      );
    } else {
      select.update.emit(
        this.schedule.channels.filter((channel) => !channel.isLinear)
      );
    }
  }

  linearChannelsSelected() {
    return (
      this.schedule.channels.filter((channel) => channel.isLinear).length ===
      this.channels.filter((channel) => channel.isLinear).length
    );
  }

  selectDigitalChannels(select: NgModel, event) {
    if (event.checked) {
      select.update.emit(
        this.schedule.channels.concat(
          this.channels.filter((channel) => !channel.isLinear)
        )
      );
    } else {
      select.update.emit(
        this.schedule.channels.filter((channel) => channel.isLinear)
      );
    }
  }

  digitalChannelsSelected() {
    return (
      this.schedule.channels.filter((channel) => !channel.isLinear).length ===
      this.channels.filter((channel) => !channel.isLinear).length
    );
  }
  /**
   * Get schedule channels according to the language
   */
  getChannels() {
    if (this.schedule && this.schedule.languages) {
      this.schedule.channels = [];
      this.loading = true;
      this.channelService
        .getScheduleChannels(this.schedule.languages)
        .subscribe((channels) => {
          this.channels = channels;
          this.loading = false;
        });
    }
  }

  /**
   * Show the magic box scheduling queue
   */
  ShowMbxSchedule() {
    if (!this.gridVisible) {
      this.scheduleService.getAllMagicBoxSchedule().subscribe((schedule) => {
        this.scheduleMbx = schedule;
        this.gridVisible = true;
      });
    } else {
      this.gridVisible = false;
    }
  }

  // check if magicbox can be inserted
  CheckMagicBoxScheduleAvailibility() {
    this.canBeScheduled = false;
    if (
      this.schedule.startDate &&
      this.schedule.endDate &&
      this.schedule.channels.length > 0
    ) {
      this.scheduleService
        .checkMagicBoxScheduleAvailibility(this.schedule)
        .subscribe((schedule) => {
          this.canBeScheduled = schedule;
        });
    }
  }

  ShowInformationSchedule() {
    this.infoVisible = !this.infoVisible;
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/magic-box-schedule/magic-box-schedule.component.ts